import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {PreviewBuilderModel, PreviewerLinkTypesEnum} from '../../../../models/api/previewerModel';
import {EditorSection} from '../../../editors/commons/editorSection';
import {Expression} from '../../../editors/expressions/expressionModel';
import {PreviewerEditorStateActions} from '../../../editors/previewerEditor/usePreviewerEditorState';
import {PreviewerBuilderCard} from '../cards/previewerBuilderCard';

/*
 * Props.
 */

interface PreviewerBuilderSectionProps {
  expressions: ReadonlyArray<Expression>;
  linkType: PreviewerLinkTypesEnum;
  onUpdateLinkType: PreviewerEditorStateActions['onUpdateLinkType'];
  previewBuilder: PreviewBuilderModel;
  onUpdatePreviewBuilder: PreviewerEditorStateActions['onUpdatePreviewBuilder'];
  isReadOnly: boolean;
}

/*
 * Component.
 */

export const PreviewerBuilderSection: FC<PreviewerBuilderSectionProps> = (props) => {
  const {expressions, linkType, onUpdateLinkType, previewBuilder, onUpdatePreviewBuilder, isReadOnly} = props;

  const renderTooltip = () => (
    <Trans id="previewer-editor-builder-tooltip">
      Rich data attached to the link will be used to show a helpful preview when the link is referenced. It
      can also be used in smart rules.
    </Trans>
  );

  return (
    <EditorSection
      description={<Trans id="previewer-editor-builder">Link preview</Trans>}
      renderTooltip={renderTooltip}
    >
      <PreviewerBuilderCard
        expressions={expressions}
        linkType={linkType}
        onUpdateLinkType={onUpdateLinkType}
        previewBuilder={previewBuilder}
        onUpdatePreviewBuilder={onUpdatePreviewBuilder}
        isReadOnly={isReadOnly}
      />
    </EditorSection>
  );
};
